import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ReceiverState {
  orderData: unknown | null;
  itemImages: string[];
  setOrderData: (data: unknown) => void;
  setItemImages: (images: string[]) => void;
  clearReceiverData: () => void;
}

export const useReceiverStore = create<ReceiverState>()(
  persist(
    (set) => ({
      orderData: null,
      itemImages: [],

      setOrderData: (data) => {
        set({ orderData: data });
      },

      setItemImages: (images) => {
        set({ itemImages: images });
      },

      clearReceiverData: () => set({ orderData: null, itemImages: [] }),
    }),
    {
      name: 'receiver-storage',
    }
  )
);
